const ErrorMessage = ({
  message = 'No results found. Please try again with a new keyword or two!',
}) => {
  return (
    <div className="text-center">
      <img
        alt={message}
        css={`
          width: 10.625rem;
          height: 10.75rem;
        `}
        src="/static/img/search-error@2x.png"
      />
      <p>{message}</p>
    </div>
  );
};

export default ErrorMessage;
